
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M64 496h192c0 5.5.1 10.9 2.8 16H64c-35.35 0-64-28.7-64-64V64C0 28.65 28.65 0 64 0h140.1c12.7 0 25 5.057 34 14.06L369.9 145.9c9 9 14.1 21.3 14.1 34v119.7l-16 16V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.24c-1.3-.16-2.6-.24-3.9-.24H64c-26.51 0-48 21.49-48 48v384c0 26.5 21.49 48 48 48zm297.1-336c-.8-1-1.6-1.9-2.5-2.7L226.7 25.37c-.8-.87-2.6-1.69-2.7-2.44V136c0 13.3 10.7 24 24 24h113.1zm-68.4 347.2c-4-4-5.6-9.8-4.2-16.1l15-59.3c1.4-5.6 4.3-10.7 8.4-15.7l181.3-180.4c15.6-15.6 40.9-15.6 56.6 0l14.3 14.4c15.7 15.6 15.7 40.9 0 56.6L382.9 487.9c-4.1 4.1-9.3 7-14.9 8.4l-60.1 15.1c-5.5 1.3-11.2-.3-15.2-4.2zm11.3-11.4l60.1-15c2.8-.7 5.4-2.1 7.5-4.2l142.8-142.9-48.3-48.3-142.9 142.9c-2 2-3.5 4.6-4.2 7.4l-15 60.1zm248.8-234.4L538.4 247c-9.3-9.3-24.5-9.3-33.9 0l-27.1 27.1 48.3 48.3 27.1-27c9.4-10.3 9.4-24.6 0-34zM364.6 482.8l3.4 13.5z"}})])
          )
        }
      }
    